import {UrlSerializer, UrlTree, DefaultUrlSerializer} from '@angular/router';

declare function unescape(s:string): string;

export class CustomUrlSerializer implements UrlSerializer {
    parse(url: any): UrlTree {
      const dus = new DefaultUrlSerializer();
      return dus.parse(unescape(url));
    }
  
    serialize(tree: UrlTree): any {
      const dus = new DefaultUrlSerializer();
      return dus.serialize(tree);
    }
  }


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/angular-router-loader/src!./src/app/threshold/services/custom-url-serializer.service.ts